import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Loading from '_shared/components/loading';
import {track} from '../../../track';

class GoogleCallback extends React.Component {

  componentDidMount() {
    track('signupFlow', {
      step: '/google/callback',
      productId: this.props.productId
    });
  }

  render() {
    return (
      <Loading actionName="getGoogleInfo">
        Your Google login was successful
      </Loading>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    productId: state.setProduct
  }
};

export default connect(mapStateToProps)(GoogleCallback);



/** WEBPACK FOOTER **
 ** ./src/app/components/googleCallback/index.jsx
 **/